import { filterParams, formatPics} from '@/common/utils/format'
import { get } from 'lodash-es'
import { i18n, getBDCountry } from '@/common/utils/i18n'
const country = getBDCountry() || 'MX'
import { getUserInfo } from '@/api'



// 从后端去取哪些字段显示在当前页面上
const PARAMS_KEYS_LIST = [
  'name',
  'ka',
  'kpName',
  'kpPhone',
  'kpEmail',
  'sellerName',
  'sellerPhone',
  'kpOutId',
  'kpPics'
]

// 对后端接口下发的数据做格式转换
export function revert (data = {}) {
  const partyInfo = get(data, 'bizGlobal', {})
  return {
    ...filterParams(PARAMS_KEYS_LIST, partyInfo),
    kpPics: formatPics(partyInfo.kpPics)

  }
}

export async function submitFormat (partyInfo) {
    const updateParams = partyInfo
    // sellerName要求特殊处理，用户不感知，但是会默认把当前用户塞进去作为销售姓名
    const currentUserInfo = await getUserInfo().then(res=>res.data) || {}
    const currentUserName = currentUserInfo.username || ''
    if(!updateParams.sellerName){
      updateParams.sellerName = currentUserName
    }else{
      const sellerNameList = updateParams.sellerName.split(',')
      if (currentUserName && !sellerNameList.includes(currentUserName)) {
      updateParams.sellerName = [
          currentUserName,
          ...sellerNameList
        ].join(',')
      }
    }
    // 销售电话要求和加特兰保持一致，墨西哥与巴西不传值, 其他国家传第一个销售电话,如果没有销售电话，则什么也不传，否则由于销售电话长度限制会报错
    if(country==='MX' || country==='BR'){
      delete updateParams.sellerPhone
    }else{
      if(updateParams.sellerPhone){
        updateParams.sellerPhone = updateParams.sellerPhone.split(',')[0] || ''
      }
      if(!updateParams.sellerPhone){
        delete updateParams.sellerPhone
      }
    }
    return {
      params: JSON.stringify({
        source: 'contractor',
        queryId: this.$route.params.id,
        bizGlobal: {
          ...updateParams,
          country: country
        }
      })
    }
}

export default {
  revert,
  submitFormat
}
